import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('loading', {
            onLoading: 'isLoading',
            anyLoading: 'anyLoading',
        }),
    },

    methods: {
        startLoading(loaderName = 'default') {
            this.$startLoading(loaderName);
        },

        endLoading(loaderName = 'default') {
            this.$endLoading(loaderName);
        },
    },
};
